import React from 'react'
import Top from './Top'
import VFooter from './VFooter'
import { Card } from './ui';

export default function PrivacyPolicy() {
  return (
    <div>
      <Top/>
      {/* Privacy Policy Section */}
<section className="py-16 px-4  mt-10 sm:px-6 lg:px-8 bg-[#f4ece5]">
  <div className="max-w-4xl mx-auto bg-white p-6 sm:p-8 md:p-10 rounded-xl shadow-lg">
    <div className="text-center mb-10">
      <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Privacy Policy</h2>
      <p className="text-lg text-gray-600 max-w-3xl mx-auto">
        At Vasstr, we are committed to protecting your privacy and ensuring the security of your designs.
      </p>
    </div>

    <div className="space-y-8">
      <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#ca7751]">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Information Collection</h3>
        <p className="text-gray-600">
          We collect details you provide during registration, including your name, email, and bank information for payments.
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#ca7751]">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Design Protection</h3>
        <p className="text-gray-600">
          Your designs are securely stored on our platform, and we will not share them with anyone without your consent.
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#ca7751]">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Use of Information</h3>
        <p className="text-gray-600">
          We use your information to process orders, communicate with you, and handle payments.
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#ca7751]">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Data Security</h3>
        <p className="text-gray-600">
          We implement industry-standard security measures to protect your information from unauthorized access.
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#ca7751]">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Changes to Privacy Policy</h3>
        <p className="text-gray-600">
          We may update this policy from time to time, and any changes will be communicated to you.
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#ca7751]">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Governing Law</h3>
        <p className="text-gray-600">
          This Privacy Policy is governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana.
        </p>
      </div>
    </div>
  </div>
</section>
      <VFooter/>
    </div>
  )
}
